export enum Product {
  FLOKEE = 'flokee',
  CLEEPO = 'cleepo',
  UNKNOWN = 'unknown',
}

export function detectProductFromDomain(): Product {
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes('flokee.ai')) {
    return Product.FLOKEE;
  }

  if (hostname.includes('cleepo.ai')) {
    return Product.CLEEPO;
  }

  return Product.UNKNOWN;
}

export function getGtmIdForCurrentDomain(): string | null {
  const product = detectProductFromDomain();

  switch (product) {
    case Product.FLOKEE:
      return import.meta.env.VITE_APP_FLOKEE_GTM_ID || null;
    case Product.CLEEPO:
      return import.meta.env.VITE_APP_CLEEPO_GTM_ID || null;
    default:
      // Fallback to Cleepo GTM ID for unknown domains
      return import.meta.env.VITE_APP_CLEEPO_GTM_ID || null;
  }
}
